import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export type CrmRole = "sales_agent" | "sales_manager" | "crm_admin";

export interface CrmMembership {
  id: string;
  user_id: string;
  role: CrmRole;
  display_name: string | null;
  is_active: boolean;
  activated_at: string | null;
}

export function useCrmMembership() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["crm-membership", user?.id],
    enabled: !!user?.id,
    queryFn: async (): Promise<CrmMembership | null> => {
      const { data, error } = await supabase
        .from("crm_users")
        .select("id, user_id, role, display_name, is_active, activated_at")
        .eq("user_id", user!.id)
        .eq("is_active", true)
        .maybeSingle();
      if (error) throw error;
      return (data as CrmMembership | null) ?? null;
    },
    staleTime: 60_000,
  });
}

export function isCrmManager(role?: CrmRole | null) {
  return role === "sales_manager" || role === "crm_admin";
}
export function isCrmAdmin(role?: CrmRole | null) {
  return role === "crm_admin";
}